import { useTranslation } from 'react-i18next';

const BandoBanner = () => (
  <div className="w-full overflow-hidden bg-[#f5ede6] border-b border-terracotta-200">
    <div className="px-6 py-3 flex flex-col sm:flex-row items-center gap-4">
      <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4 min-w-0 w-full">
        <img
          src="https://static.readdy.ai/image/13e0fae89bbbd02d36954a6d83bda5fb/fea88aaaf8bd8d331a22269f77a259a8.png"
          alt="Coesione Italia 21-27 Marche — Cofinanziato dall'Unione Europea — Repubblica Italiana — Regione Marche"
          className="h-24 w-auto object-contain shrink-0 self-center sm:self-start"
          loading="lazy"
          decoding="async"
        />
        <p className="font-sans text-sm text-stone-700 leading-snug min-w-0 text-center sm:text-left">
          <strong className="text-terracotta-500 font-semibold">Bando Regione Marche</strong>
          {' '}—<br />Contributi per il recupero e la valorizzazione dei borghi storici marchigiani.{' '}
          <span className="text-stone-500 text-xs"></span>
        </p>
      </div>
      <a
        href="/progetto"
        className="shrink-0 font-sans text-xs tracking-widest uppercase px-5 py-2 border border-terracotta-400 text-terracotta-500 hover:bg-terracotta-400 hover:text-white transition-all duration-200 rounded-full cursor-pointer whitespace-nowrap"
      >
        Il progetto
      </a>
    </div>
  </div>
);

const HeroSection = () => {
  const { t } = useTranslation();

  const scrollToProperties = () => {
    const el = document.querySelector('#immobili');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToNext = () => {
    const el = document.querySelector('#visione');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const taglineLines = t('hero.tagline').split('\n');

  return (
    <>
    <section
      id="hero"
      className="relative h-screen min-h-[640px] flex flex-col items-center justify-center overflow-hidden"
      aria-label="Hero"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Marche%20Italy%20rolling%20hills%20golden%20sunset%20panoramic%20landscape%20ancient%20farmhouse%20terracotta%20roofs%20olive%20groves%20vineyards%20warm%20amber%20orange%20sky%20dramatic%20light%20beautiful%20Italian%20countryside%20borghi%20Ancona&width=1920&height=1080&seq=hero001&orientation=landscape"
          alt="Colline marchigiane al tramonto — borghi storici Marche"
          className="w-full h-full object-cover object-center"
          fetchPriority="high"
          decoding="async"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full flex flex-col items-center text-center px-6">
        <p
          className="font-sans text-xs tracking-widest2 uppercase text-white mb-8"
          style={{ animation: 'fadeInUp 1.2s ease-out 0.3s forwards', opacity: 0, textShadow: '0 0 20px rgba(255,255,255,0.5), 0 1px 8px rgba(0,0,0,0.5)' }}
        >
          I BORGHI MARCHIGIANI
        </p>

        <h1
          className="font-serif text-4xl md:text-6xl lg:text-7xl text-white font-light leading-tight max-w-4xl mb-10"
          style={{ animation: 'fadeInUp 1.2s ease-out 0.6s forwards', opacity: 0, textShadow: '0 0 40px rgba(255,255,255,0.3), 0 2px 16px rgba(0,0,0,0.4)' }}
        >
          {taglineLines.map((line, i) => (
            <span key={i}>
              {i === 1 ? <em className="not-italic font-light">{line}</em> : line}
              {i < taglineLines.length - 1 && <br />}
            </span>
          ))}
        </h1>

        <div style={{ animation: 'fadeInUp 1.2s ease-out 1s forwards', opacity: 0 }} className="flex flex-col sm:flex-row items-center gap-4">
          <a
            href="/borghi"
            className="font-sans text-sm tracking-widest uppercase px-10 py-4 bg-terracotta-300 text-white hover:bg-terracotta-400 transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap rounded-full inline-block"
          >
            Scopri i Borghi
          </a>
          <a
            href="/contatti"
            className="font-sans text-sm tracking-widest uppercase font-bold px-10 py-4 bg-white text-stone-800 hover:bg-stone-100 transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap rounded-full inline-block"
          >
            Contattaci
          </a>
        </div>
      </div>

      {/* Scroll indicator */}
      <button
        onClick={scrollToNext}
        className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 cursor-pointer group"
        style={{ animation: 'fadeIn 1s ease-out 1.8s forwards', opacity: 0 }}
        aria-label="Scroll down"
      >
        <span className="font-sans text-xs tracking-widest2 uppercase text-white group-hover:text-white transition-colors" style={{ textShadow: '0 1px 8px rgba(0,0,0,0.5)' }}>
          {t('hero.scroll')}
        </span>
        <div className="w-5 h-8 flex items-center justify-center text-white/80 group-hover:text-white transition-colors"
          style={{ animation: 'bounceDown 1.8s ease-in-out infinite' }}>
          <i className="ri-arrow-down-line text-lg"></i>
        </div>
      </button>

      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(28px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes bounceDown {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(8px); }
        }
      `}</style>
    </section>
    <BandoBanner />
    </>
  );
};

export default HeroSection;
